// Data colouring shared by tables, compact lists and detail panes (2026-10-09,
// customer request with mock-ups: "more colours" so amounts, customer names and
// the other important figures stand out from the surrounding text). The CSS lives
// in style/scss/pages/_customisedstyle.scss under "Data colours".

// Column titles that hold money. Matched as whole words, so "Collections (12 m)"
// (a count) is left alone while "Amount (12 m)" is coloured.
export const MONEY_TITLE_RE =
  /\b(amount|amt|total|balance|value|paid|collected|price|cost|due|outstanding|net|vat|expense|spend|spent|ksh|kes|refill|refills|debit|credit|opening|closing|salary)\b/i;

// Column titles that name the party - whole title only, so "Customers with no
// collector" (a count) is not mistaken for a name column.
export const PARTY_TITLE_RE = /^\s*(customer|client|supplier|party|vendor|payee|customer\s*\/\s*site)(\s*name)?\s*$/i;

// A finished figure as the shared money() helpers print it: 1,234.00 / -50.5 / 0.00
const FIGURE_RE = /^\s*(KSh\s*)?-?[\d,]+(\.\d+)?\s*$/i;

export const isFigure = (rendered) =>
  (typeof rendered === "string" || typeof rendered === "number") && FIGURE_RE.test(String(rendered));

/** Extra class for one rendered money cell: red when negative, grey when zero. */
export const moneyToneClass = (rendered) => {
  if (!isFigure(rendered)) return "";
  const n = Number(String(rendered).replace(/KSh|,|\s/gi, ""));
  if (n < 0) return "tx-money-neg";
  if (n === 0) return "tx-money-zero";
  return "";
};

// Avatar circles get a steady colour per person instead of all being maroon,
// so the same requester is recognisable down a list.
const AVATAR_COLORS = ["#6E1423", "#1F5FAD", "#0B7A55", "#B0570B", "#6A3FB5", "#0E7C86", "#B02A6B", "#4A5A6A"];

export const avatarColor = (label) => {
  const s = String(label || "");
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
};
